package com.neurobs.ccabserver.translationadmin.components.translationprogress.components

import com.neurobs.ccab.translation.TranslatorDataView
import com.neurobs.ccabserver.translationadmin.states.TranslationProgressStateGenerator
import com.neurobs.react.{ReactElementFactory, ReactUtil}
import com.neurobs.react.semanticui.{UiButtonFactory, UiDividerFactory, UiHeaderFactory, UiLoaderFactory, UiMessageFactory}
import slinky.core.FunctionalComponent
import slinky.core.annotations.react
import slinky.core.facade.ReactElement

import scala.scalajs.js

@react
object TranslatorSelection {
  case class Props(enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    val translationProgressState = TranslationProgressStateGenerator.accessState

    props.enclosingElement(
      translationProgressState.translatorsState.value match {
        case Left(errorOpt) => errorOpt match {
          case None => Seq(UiLoaderFactory.ActiveTextLoader("Loading server translators")("mini"))
          case Some(error) => Seq(UiMessageFactory.BasicErrorMessage(error))
        }
        case Right(translators) => translators.groupBy(_.userId).toSeq.map(grouping => {
          val (userId, translatorDataViews) = grouping
          TranslatorLanguageOption(
            userId,
            translatorDataViews,
            ReactElementFactory.Div(_)
          )
        })
      }
    )
  }
}

@react
object TranslatorLanguageOption {
  case class Props(userId: Long, translatorDataViews: List[TranslatorDataView], enclosingElement: (ReactElement*) => ReactElement)
  val component = FunctionalComponent[Props] { props =>

    def username = props.translatorDataViews(0).username
    def headerStyle = Seq[(String, js.Any)](("fontWeight", "bold"))

    val translationProgressState = TranslationProgressStateGenerator.accessState

    def handleSelect(translatorDataView: TranslatorDataView) = () => {
      translationProgressState.selectTranslator(translatorDataView)
    }

    props.enclosingElement(
      Seq[ReactElement](
        UiHeaderFactory.TextHeader(username, 4)(headerStyle),
        props.translatorDataViews.map(view => {
          UiButtonFactory.Button(
            view.languageDisplayName,
            handleClick = handleSelect(view)
          )("mini")
        })
      )
    )

  }
}
